import React from "react";

/**
 * Wraps substring matches of `query` in `text` with <mark className="ac-select-option-highlight">.
 * Case-insensitive; safe when `query` contains regex metacharacters.
 */
export function highlightSearchMatch(
  text: string,
  query: string
): React.ReactNode {
  const q = query.trim();
  if (!q || !text) {
    return text;
  }
  const esc = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  let re: RegExp;
  try {
    re = new RegExp(`(${esc})`, "gi");
  } catch {
    return text;
  }
  const parts = text.split(re);
  return (
    <>
      {parts.map((part, index) => {
        if (part === "") {
          return null;
        }
        if (index % 2 === 1) {
          return (
            <mark
              key={`h-${index}-${part}`}
              className="ac-select-option-highlight"
            >
              {part}
            </mark>
          );
        }
        return <span key={`t-${index}-${part}`}>{part}</span>;
      })}
    </>
  );
}
